module.exports = __webpack_public_path__ + "static/image/sustainability/pc/ethical@3x.ver2_0_2.jpg?b00dcbb4";